export default [
    {
      path: '/admin/stock-return',
      name: 'stock-return',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/stock-return/index.vue')
    },
    {
      path: '/admin/stock-return/create',
      name: 'stock-return-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/stock-return/create.vue')
    },
    {
      path: '/admin/stock-return/:id/edit',
      name: 'stock-return-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/stock-return/edit.vue')
    }
  ]
  